import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDqp53SPgkctC5dEz7x5RGU_ID1H6hUApg",
  authDomain: "myexcalidraw-b7728.firebaseapp.com",
  projectId: "myexcalidraw-b7728",
  storageBucket: "myexcalidraw-b7728.firebasestorage.app",
  messagingSenderId: "586870069097",
  appId: "1:586870069097:web:3264e2d5e84d18bf0ecff8"
};

const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
export const auth = app.auth();
export const db = app.firestore();
